module.exports = __webpack_public_path__ + "static/media/ontvangen.9b893001.svg";